import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { DataTable, MessageService } from 'primeng/primeng';
import { FormGroup, FormControl } from '@angular/forms';
import { CaseCreationView } from '../../models/caseCreationView';
import { ScreeningService } from '../../services/screening.service';
import { AutoCompleteDropDown } from '../../models/autoComplete';
import { CommonService } from '../../services/common.service';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { AuthService } from '../../services/auth.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatOptionSelectionChange } from '@angular/material/core';

@Component({
  selector: 'app-bulkinvitation',
  templateUrl: './bulkinvitation.component.html',
  styleUrls: ['./bulkinvitation.component.css']
})
export class BulkinvitationComponent implements OnInit {
  userData: any;
  routePath = 'Direct App / Bulk Invitation';
  btnExport = true;
  btnAddUpload = true;
  btnValidate = true;
  btnReset = true;
  @ViewChild('dt', null) dt: DataTable;
  @ViewChild('history', null) history: TemplateRef<any>;
  bulkFormGroup: FormGroup;
  clientId = new FormControl();
  siteNo = new FormControl();
  clients = [];
  clientControls: AutoCompleteDropDown;
  // tslint:disable-next-line: no-use-before-declare
  model = new BulkUploadDoc();
  sites = [];
  sitefilterlist = [];
  docList = [];
  bulkUploadDoc: any;
  @ViewChild('uploadConfirm', null) uploadConfirm: TemplateRef<any>;
  displayedImportCol = [
    { field: 'excelRow', header: 'Row Number' },
    { field: 'name', header: 'Candidate Name' },
    { field: 'detail', header: 'Error Details' },
    { field: 'status', header: 'Status' },
  ];
  docErrorList = [];
  dupErrorList = [];
  totalpages: number;
  currentPage = 1;
  tempCurrentPage = 1;
  packAndCompList: any;
  viewError: any;
  screenAuth: any;
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';
  isSaved: boolean = false;
  showGrid = false;
  bulkInvitationColumns: any[] = [];
  packAndCompList1: any = {};

  bulkInvitationList: BulkInvitation[] = [];

  isBulkInvValid: boolean = true;
  isExcelValid: boolean = false;
  isApplyAll: boolean = false;
  isInvitationSent: boolean = false;
  isAllowExistInvitation: boolean = false;

  constructor(public screening: ScreeningService, private message: MessageService, public common: CommonService,
    public dialog: MatDialog, private router: Router, private authService: AuthService) { }

  ngOnInit() {
    this.userData = JSON.parse(sessionStorage.getItem('user_data'));
    this.screenAuth = this.authService.getScreenAuth(this.router.url);
    this.initFormGroup();
    this.getClients();
    //this.getCaseImportTemplete();
    this.bulkFormGroup.get('siteNo').disable();
    this.initializeColumns();
  }
  // Define Table Columns
  initializeColumns() {
    this.bulkInvitationColumns = [
      { field: 'sno', header: 'S.No' },
      { field: 'firstName', header: 'Candidate Name' },
      { field: 'email', header: 'Email Address' },
      { field: 'packageId', header: 'Select Package' },
      { field: 'packDetails', header: 'Package Details' },
      { field: 'indComp', header: 'Select Component' },
      { field: 'comps', header: 'Component Details' }
    ];
  }


  packageName(val, data) {
    if (val !== undefined) {
      this.screening.getComponentByPackageId(val).subscribe(res => {
        if (res) {
          data.packCompList = res;
        }
      });
    }
    else {
      data.packCompList = [];
    }
    if (this.isApplyAll)
      this.isApplyAll = false;
  }

  onSubCompSelectionChange(event: MatOptionSelectionChange): void {
    if (event.isUserInput && this.isApplyAll)
      this.isApplyAll = false;
  }



  // setSubCompValue(value, main, sub) {
  //   if (value) {
  //     const val = this.common.CloneObject(main);
  //     val.packageSubComponent = [];
  //     val.packageSubComponent.push(sub);
  //     return val;
  //   }
  // }

  compareComponents = function (a, b) {
    if (!a || !b) return false;

    if (a.subCompFlag && b.subCompFlag) {
      const aSub = a.packageSubComponent && a.packageSubComponent.length > 0 ? a.packageSubComponent[0] : null;
      const bSub = b.packageSubComponent && b.packageSubComponent.length > 0 ? b.packageSubComponent[0] : null;

      return a.compId === b.compId &&
        aSub && bSub &&
        aSub.subCompId === bSub.subCompId;
    }

    return a.compId === b.compId;
  };



  setSubCompValue(main, sub) {
    const val = { ...main }; // shallow clone is enough if packageSubComponent is overwritten
    val.packageSubComponent = [sub];
    return val;
  }

  initFormGroup() {
    this.bulkFormGroup = new FormGroup({
      clientId: new FormControl(''),
      siteNo: new FormControl('')
    });
    this.clientControls =
      new AutoCompleteDropDown('Client Name', 'clientId', 'clientId', 'clientName', this.clients,
        '', this.bulkFormGroup, false, false, true);
  }
  getCaseImportTemplete() {
      this.screening.getCaseImportTemplete(false, true, false, false, false, false).subscribe(res => {
        if (res) {
          this.docList = res;
          const sampleArr = this.common.base64ToArrayBuffer(res.document);
          this.bulkInvitationExcel(sampleArr, res.fileName);
        }
      });
  }

  bulkInvitationExcel(sampleArr: any, fileName: string) {
    const blob = new Blob([sampleArr], { type: 'application/octet-stream' });
    const fileReader = new FileReader();
  
    fileReader.readAsArrayBuffer(blob);
  
    fileReader.onload = () => {
      const arrayBuffer = fileReader.result as ArrayBuffer;
      const data = new Uint8Array(arrayBuffer);
      const arr = Array.from(data, byte => String.fromCharCode(byte));
      const bstr = arr.join("");
  
      const XLbook = XLSX.read(bstr, { type: "binary" });
      const firstSheetName = XLbook.SheetNames[0];
      const XLsheet = XLbook.Sheets[firstSheetName];
      const rows: any[][] = XLSX.utils.sheet_to_json(XLsheet, { header: 1, raw: true });
  
      if (rows.length === 0) return;
  
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(fileName);
  
      // Add header row
      const headerRow = worksheet.addRow(rows[0]);
  
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'bed6fa'},
          bgColor: {argb: 'b570f5'}
        };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      });
  
      // Set column widths based on first row content
      rows[0].forEach(function(cell, index) {
        var length = (cell && cell.toString()) ? cell.toString().length : 10;
        worksheet.getColumn(index + 1).width = length > 27 ? length / 2 : 27;
      });

      // Add remaining rows
      for (let i = 1; i < rows.length; i++) {
        worksheet.addRow(rows[i]);
      }
  
      // Save the Excel file
      workbook.xlsx.writeBuffer().then((data) => {
        const exportBlob = new Blob([data], { type: this.EXCEL_TYPE });
        fs.saveAs(exportBlob, fileName);
      });
    };
  }
  


  bulkInvitationExcel_OLD(sampleArr, fileName) {
    let comp = []; let pack = []; let compDrop = []; let packDrop = [];
    this.packAndCompList.component.forEach((element, index) => {
      comp.push((index + 1) + ').' + (element.subCompFlag === true ? element.compName + ' - ' +
        (element.packageSubComponent.map(x => x = x.subCompName).join(',')) : element.compName));
      if (element.subCompFlag == true) {
        element.packageSubComponent.forEach(subele => {
          compDrop.push(element.compName + ' - ' + subele.subCompName);
        });
      } else {
        compDrop.push(element.compName);
      }
    });
    this.packAndCompList.package.forEach((e, i) => {
      pack.push((i + 1) + ').' + (e.packageName));
      packDrop.push(e.packageName);
    });
    const blob = new Blob([sampleArr], { type: 'application/octet-stream' });
    let arrayBuffer;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(blob);
    fileReader.onload = (e) => {
      arrayBuffer = fileReader.result;
      var data = new Uint8Array(arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      const list1 = XLSX.utils.sheet_to_json(worksheet, { header: 1, raw: true, });
      this.exportBulkInvitationExcel(comp, pack, list1[1], fileName, list1[0], compDrop, packDrop);
    }
  }
  exportBulkInvitationExcel(comp, pack, json, excelFileName: string, headersArray, compDrop, packDrop) {
    const i1 = headersArray.findIndex(x => x === 'Client Components List');
    const i2 = headersArray.findIndex(x => x === 'Client Packages List');
    json[i1] = comp.join(', ');
    json[i2] = pack.join(', ');
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(excelFileName);
    const headerRow = worksheet.addRow(headersArray);

    headerRow.eachCell((cell) => {
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'bed6fa' }, bgColor: { argb: 'b570f5' } };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    headersArray.forEach((headers, i) => {
      if ((i === i1 || i === i2) && (json[i].length > 270)) {
        worksheet.getColumn(i + 1).width = json[i].length / 8;
      } else {
        worksheet.getColumn(i + 1).width = 27;
      }
    });
    worksheet.addRow(json);
    for (var i = 0; i <= 1000; i++) {
      worksheet.getCell('N' + (+i + 2)).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: ['=CompDropList'] //['"' + compDrop + '"']
        //formulae: ['"1).Address - Current Address,Permanent Address,Previous Address, 2).Address - Geo - Previous Address,Permanent Address,Current Address, 3).Bank Statement, 4).Company Site Visit, 5).Credit Verification, 6).Criminal - Federal Nationwide 5 Years, 8).Criminal (Court Record), 9).Criminal Check (PCC1), 10).Criminal Check (PCC2), 11).Criminal Check (PCC3), 12).Criminal Check (PCC3E), 13).Criminal Database, 14).CV Validation, 15).Directorship, 16).Drug Test - 5 Panel, 17).Education, 18).Emergency Contact Verification, 20).EMPLOYEMENT (UAN), 21).Employment (HR), 22).Employment (Supervisor), 23).Gap Verification, 24).Judis Court Record, 25).License, 26).National Identity Check, 27).Nationwide Sex Offender 5 Years, 28).NDOT Drug Screen, 30).Online CRC, 31).Online CRC (Internal), 32).PAN Card, 33).PAN India Online Court Record Verification - Current Address,Previous Address, 34).Passport, 35).Reference Check, 36).Reference Self-employed, 37).SSN Trace, 38).Voter ID"']
      };
    };
    if (json[i2] != null && json[i2] != "") {
      for (var i = 0; i <= 1000; i++) {
        worksheet.getCell('M' + (+ i + 2)).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: ['=CompDropList']  //['"' + packDrop + '"']
        };
      }
    }
    worksheet.getCell('J2').alignment = {
      wrapText: true
    };
    worksheet.getCell('K2').alignment = { wrapText: true };
    worksheet.getCell('L2').alignment = { wrapText: true };
    workbook.xlsx.writeBuffer().then((data1) => {
      const blob = new Blob([data1], { type: this.EXCEL_TYPE });
      fs.saveAs(blob, excelFileName);
    });
  }

  getClients() {
    const data = new CaseCreationView();
    data.teamId = this.userData.teamId;
    data.applicationId = this.userData.applicationId;
    data.clientId = this.userData.clientId;
    data.teamName = this.userData.teamName;
    this.screening.getInvitationClientName(data).subscribe(resp => {
      if (resp) {
        this.clients = resp;
        this.clientControls =
          new AutoCompleteDropDown('Client Name', 'clientId', 'clientId', 'clientName', this.clients,
            '', this.bulkFormGroup, false, false, true);
      }
    });
  }
  getClientId(clientId) {
    if (clientId) {
      this.removeDocument();
      if (this.clients.find(x => x.clientId === clientId).agreementPendingFlag === true) {
        this.showTopCenter('warn', 'Failure Message', 'The client has pending in agreement approval...');
        this.bulkFormGroup.get('clientId').setValue(null); return;
      } else {
        this.sites = [];
        this.bulkFormGroup.controls.siteNo.setValue(undefined);
        setTimeout(() => {
          this.getSiteLocation(clientId);
        }, 20);
        this.bulkFormGroup.controls.siteNo.enable();
      }
    }
  }
  resetForm() {
    this.bulkFormGroup.reset();
    this.bulkFormGroup.markAsPristine();
    this.bulkFormGroup.markAllAsTouched();
    this.removeDocument();
  }
  getSiteLocation(clientId) {
    this.screening.getSiteNoByClientId(clientId).subscribe((resp) => {
      if (resp) {
        resp.map(e => {
          e.siteNoWithsiteName = e.siteNo + '-' + e.siteName;
        });
        this.sites = resp;
      }
      if (resp.length === 0) {
        this.bulkFormGroup.get('siteNo').disable();
        this.sitefilterlist = [];
      }
    }, err => {

    }, () => {
      if (this.sites.length === 0) {
        this.bulkFormGroup.controls.siteNo.disable();
      } else {
        this.bulkFormGroup.controls.siteNo.enable();
        this.siteItems('');
      }
    });
  }
  siteItems(value) {
    if (!value) { this.assignCompCopy(); }
    if (value) {
      this.sitefilterlist = Object.assign([], this.sites).filter(
        item => ((item.siteNoWithsiteName.toLowerCase().indexOf(value.toLowerCase()) > -1)));
    }
  }
  assignCompCopy() {
    this.sitefilterlist = Object.assign([], this.sites);
  }
  siteKeyupFunction(event, value) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      return false;
    } else {
      if (value) {
        const comp = this.sites.filter(e =>
          e.siteNoWithsiteName.toLowerCase() === value.toLowerCase());
      }
    }
  }
  get displaySiteFn() {
    const compNew = (comp) => {
      if (comp == null || comp === undefined) {
        return null;
      } else {
        if (comp && this.sitefilterlist && this.sitefilterlist.length > 0) {
          comp = this.sitefilterlist.find(x => x.siteId === comp);
          if (comp.siteNoWithsiteName) {
            return comp.siteNoWithsiteName;
          }
        } else {
          return null;
        }
      }
    };
    return compNew;
  }
  openUploadDoc(event) {
    if (this.validateInputs(true)) {
      this.bulkUploadDoc = '';
      const fileName = event.target.files[0].name;
      const fileExtn = fileName.split('.').pop();
      const target: DataTransfer = <DataTransfer>(event.target);

      if (!['xls', 'xlsx'].includes(fileExtn)) {
        this.showTopCenter('warn', 'Failure Message', 'Please upload a file with Extensions: xlsx, xls');
        return;
      } else if (target.files.length !== 1) {
        this.showTopCenter('warn', 'Failure Message', 'Only one file at a time can be uploaded.');
        return;
      }

      const file = target.files[0];
      const reader: FileReader = new FileReader();

      reader.onload = (e: any) => {
        const binaryStr: string = e.target.result;
        const workbook: XLSX.WorkBook = XLSX.read(binaryStr, { type: 'binary' });

        const sheetName: string = workbook.SheetNames[0];
        const worksheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
        //const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const jsonData = rawData.filter((row: any[]) => row.some(cell => cell !== null && cell !== undefined && cell !== ''));

        const recordCount = jsonData.length - 1;
        if (recordCount > 25) {
          this.showTopCenter('warn', 'Failure Message', 'Maximum 25 records allowed in one single upload.');
          return;
        }
        this.bulkUploadDoc = event.target.files[0];
        // Extract headers (first row)
        const headers: string[] = jsonData[0] as string[];

        // Map remaining rows into BulkInvitation objects
        this.bulkInvitationList = jsonData.slice(1).map(row => {
          let obj: any = {};
          headers.forEach((key, index) => {
            obj[key] = row[index] || ''; // Assign value, handle empty cases
          });
          return new BulkInvitation(obj);
        });
        this.validateBulkUploadData();
      };
      reader.readAsBinaryString(file);
    }
  }

  getCasePackageComponent(clientId: number,siteNo: number ): void {
    this.screening.getCasePackageComponent(clientId, true, siteNo).subscribe(res => {
      if (res) {
        this.packAndCompList = res;
      }
    });
  }

  onOptionToggle(event: MatOptionSelectionChange) {
    if (event.isUserInput) {
      this.removeDocument();
      const { clientId } = this.bulkFormGroup.controls;
      this.getCasePackageComponent(clientId.value,event.source.value);
    }
  }

  removeDocument() {
    this.bulkUploadDoc = '';
    this.bulkUploadDoc = [];
    this.docErrorList = [];
    this.bulkInvitationList = [];
    this.isExcelValid = false;
    this.isApplyAll = false;
    this.isInvitationSent = false;
    this.isAllowExistInvitation = false;
  }
  downloadDoc(data) {
    this.common.downloadDocument(0, data.document, data.fileName);
  }

  validateInputs(skipFileCheck:boolean = false): boolean {
    const { clientId,siteNo } = this.bulkFormGroup.controls;
    const isFileInvalid = !this.bulkUploadDoc || this.bulkUploadDoc.length === 0;

    if (!clientId.value) {
      this.showTopCenter('warn', 'Failure Message', 'Please Select Client');
      return false;
    }
    if (!siteNo.value) {
      this.showTopCenter('warn', 'Failure Message', 'Please Select Site');
      return false;
    }

    if (isFileInvalid && !skipFileCheck) {
      this.showTopCenter('warn', 'Failure Message', 'Please upload a file to validate');
      return false;
    }

    return true;
  }



  validateUploadFile(option: any): void {
    if (!this.validateInputs()) return;

    this.bulkFormGroup.markAllAsTouched();
    this.isSaved = option;
    const isValid = this.validateBulkUploadData();

    if (isValid && option) {
      this.saveInvitationBulkUpload(option);
    } else if (isValid && this.isExcelValid) {
      this.showTopCenter('success', 'Success Message', 'Validation Completed.');
    }
    this.isSaved = false;
  }

  bulkUpload() {
    if (this.validateInputs()) {
      this.btnReset = true;
      this.btnAddUpload = true;
      this.btnValidate = true;
      this.btnExport = true;
      this.isSaved = true;
      if (this.validateBulkUploadData())
        this.uploadDialog();
      this.isSaved = false;
    }
  }
  uploadDialog() {
    if (this.bulkUploadDoc !== undefined) {
      if (this.bulkFormGroup.valid) {
        this.dialog.open(this.uploadConfirm, {
          width: '320px',
          disableClose: true
        });
      } else {
        this.bulkFormGroup.markAllAsTouched();
      }
    } else {
      this.showTopCenter('error', 'Failure Message', 'Please upload a file');
    }
  }
  saveInvitationBulkUpload(option) {
    const formData = new FormData();
    this.model.clientId = this.bulkFormGroup.controls.clientId.value;
    this.model.siteId = this.bulkFormGroup.controls.siteNo.value;
    if (this.clients.length > 0) {
      const clientName = this.clients.filter(x => x.clientId === this.model.clientId);
      this.model.clientName = clientName[0].clientName;
    }
    if (this.sitefilterlist.length > 0) {
      const siteName = this.sitefilterlist.filter(x => x.siteId === this.model.siteId);
      this.model.siteName = siteName[0].siteName;
    }
    this.model.invitationFlag = true;
    this.model.autoAssignFlag = false;
    this.model.loggedId = this.userData.userId;
    this.model.fileName = this.bulkUploadDoc.name;
    this.model.bulkUploadDoc = this.bulkUploadDoc;
    this.model.uploadStatus = option;
    this.model.isAllowExistInvitation = this.isAllowExistInvitation;
    this.model.deptId = this.userData.deptId;
    this.model.teamId = this.userData.teamId;
    formData.append('CaseCreationImport', this.bulkUploadDoc);
    formData.append('CaseCreation', JSON.stringify(this.model));


    // Process bulkInvitationList
    for (let i = 0; i < this.bulkInvitationList.length; i++) {
      let element = this.bulkInvitationList[i];
      let icomplist = '';
      let selPackage = '';

      // Extract components
      if (element.indComponentList && element.indComponentList.length > 0) {
        icomplist = element.indComponentList.map(comp => {
          if (comp.subCompFlag && comp.packageSubComponent && comp.packageSubComponent.length > 0) {
            let subCompNames = comp.packageSubComponent.map(sub => sub.subCompName).join(', ');
            return `${comp.compName} -  ${subCompNames}`;
          } else {
            return comp.compName;
          }
        }).join(',');
      }

      // Extract package
      let packageItem = this.packAndCompList.package.find(e => e.packageId === element.packageId);
      selPackage = packageItem ? packageItem.packageName : '';


      // Apply 'isApplyAll' logic
      if (this.isApplyAll && i === 0) {
        for (let j = 0; j < this.bulkInvitationList.length; j++) {
          this.bulkInvitationList[j].individualComponents = icomplist;
          this.bulkInvitationList[j].package = selPackage;
        }
        break;
      } else {
        element.individualComponents = icomplist;
        element.package = selPackage;
      }
    }

    formData.append('CaseCreationList', JSON.stringify(this.bulkInvitationList));
    this.screening.invitationCaseCreationImport(formData).subscribe(resp => {
      if (resp.fakeMasValidResponse.length > 0) {
        this.docErrorList = resp.fakeMasValidResponse;
        // this.bulkUpload();
        this.dupErrorList = this.docErrorList.filter(x => x.status === 'Success');
        if (this.dupErrorList.length === this.docErrorList.length) {
          this.showTopCenter('success', 'Success Message', 'Uploaded Successfully');
          this.bulkUploadDoc = '';
          this.dialog.closeAll();
          this.router.navigate(['dashboard/screening/manageinvitation']);
        }
      } else {
        if (resp.response.success === true) {
          this.showTopCenter('success', 'Success Message', 'Uploaded Successfully');
          this.dialog.closeAll();
        } else {
          this.showTopCenter('error', 'Failure Message', resp.response.message ? resp.response.message :
            'Please upload valid excel file.Invalid columns & update proper data');
        }
      }
      this.dialog.closeAll();
    });
  }
  openEdetails(error) {
    this.viewError = error
    this.dialog.open(this.history, {
      width: '800px',
      disableClose: true
    });
  }
  getTotalPages(totalRecords, rows) {
    this.totalpages = Math.ceil((totalRecords) / rows);
    return Math.ceil((totalRecords) / rows);
  }
  navigateNxtPrevPage(pageNo, rows) {
    this.currentPage = pageNo / rows;
    this.tempCurrentPage = this.currentPage;
  }
  navigatePage(pageNo, rowscount) {
    if (+pageNo > this.totalpages || +pageNo <= 0) {
      this.currentPage = this.tempCurrentPage;
    } else {
      this.dt.onPageChange({ first: ((pageNo - 1) * rowscount), rows: rowscount });
      this.tempCurrentPage = this.currentPage;
    }
  }
  showTopCenter(level: string, info: string, message: string) {
    this.message.add({ severity: level, summary: info, detail: message });
  }


  validateBulkUploadData(): boolean {
    const formData = new FormData();
    this.model.clientId = this.bulkFormGroup.controls.clientId.value;
    this.model.siteId = this.bulkFormGroup.controls.siteNo.value;
    if (this.clients.length > 0) {
      const clientName = this.clients.filter(x => x.clientId === this.model.clientId);
      this.model.clientName = clientName[0].clientName;
    }
    if (this.sitefilterlist.length > 0) {
      const siteName = this.sitefilterlist.filter(x => x.siteId === this.model.siteId);
      this.model.siteName = siteName[0].siteName;
    }
    this.model.invitationFlag = true;
    this.model.autoAssignFlag = false;
    this.model.loggedId = this.userData.userId;
    this.model.fileName = this.bulkUploadDoc.name;
    this.model.bulkUploadDoc = this.bulkUploadDoc;
    this.model.uploadStatus = false;
    this.model.isAllowExistInvitation = this.isAllowExistInvitation;
    this.model.deptId = this.userData.deptId;
    this.model.teamId = this.userData.teamId;
    formData.append('CaseCreationImport', this.bulkUploadDoc);
    formData.append('CaseCreation', JSON.stringify(this.model));

    if (this.isExcelValid) {
      if (!this.isApplyAll && (this.bulkInvitationList.some(e => ((!e.packageId || e.packageId < 1) && (!e.indComponentList || e.indComponentList.length === 0))))) {
        this.showTopCenter('warn', 'Failure Message', 'Please Select Components or Package...'); return false;
      }

      let mainFlag = true;
      let validationMessage: string = ""

      // Validate components in bulkInvitationList
      for (let i = 0; i < this.bulkInvitationList.length; i++) {
        let element = this.bulkInvitationList[i];

        if (!this.isApplyAll || (this.isApplyAll && i === 0)) {

          if ((!element.indComponentList || element.indComponentList.length == 0) && (!element.packageId || element.packageId < 1)) {
            mainFlag = false;
            validationMessage = "Please Select Components or Package...";
            break;
          }
          for (let j = 0; j < element.indComponentList.length; j++) {
            let ele = element.indComponentList[j];

            let isComponentInPackage = element.packCompList && element.packCompList.length > 0 && element.packCompList.some(x => x.componentId === ele.componentId && !ele.subCompFlag);

            if (isComponentInPackage && ele.maxNoOfComp && ele.maxNoOfComp < 2) {
              mainFlag = false;
              validationMessage = "Please Remove the Additional Component, If It is Already in Package, Components";
              break;
            }

            if (mainFlag && ele.subCompFlag) {
              let val = element.packCompList ? element.packCompList.find(x => x.componentId === ele.componentId) : null;
              let subComp = ele.packageSubComponent && ele.packageSubComponent.length > 0 ? ele.packageSubComponent[0] : null;
              let subCompInPackage = false;
              if (val && val.packageSubComponent && subComp) {
                subCompInPackage = val.packageSubComponent.some(x => x.subCompId === subComp.subCompId);
              }

              // Check if subComp exists, has max limit < 2, and already exists in the package
              if (subCompInPackage && subComp.maxNoOfComp && subComp.maxNoOfComp < 2) {
                validationMessage = "Please Remove the Additional Component, If It is Already in Package, Components.";
                mainFlag = false;
                break;
              }
            }
          }
        }
        if (!mainFlag) {
          break;
        }
      }

      // Show warning and exit if validation fails
      if (!mainFlag) {
        this.showTopCenter('warn', 'Failure Message', validationMessage);
        return mainFlag;
      }

      if (this.isSaved) return true;

      formData.append('CaseCreationList', JSON.stringify(this.bulkInvitationList));
    }
    else {
      formData.append('CaseCreationList', JSON.stringify(this.bulkInvitationList));
    }


    this.screening.invitationCaseCreationImport(formData).subscribe(resp => {
      if (resp.fakeMasValidResponse.length > 0) {
        this.docErrorList = resp.fakeMasValidResponse;
        this.isInvitationSent = resp.fakeMasValidResponse.some(x => x.isInvitationSent === true);;
        this.dupErrorList = this.docErrorList.filter(x => x.status === "Ready to upload");
        if (this.dupErrorList.length === this.docErrorList.length) {
          this.docErrorList = [];
          this.isExcelValid = true;
          this.showGrid = true;
        }
        else {
          this.isExcelValid = false;
          this.showGrid = false;
        }
      }
    });
    return this.isExcelValid;
  }



  onApplyAllChange(event: MatCheckboxChange): void {

    const firstRow = this.bulkInvitationList[0];
    if (this.isApplyAll) {
      // Validate the first row has at least one component or package
      if (firstRow.indComponentList.length === 0 && firstRow.packCompList.length === 0) {
        this.isApplyAll = false; // uncheck the checkbox
        this.showTopCenter('warn', 'Failure Message', "Please Select Components or Package...");
        return;
      }

      // Apply to all other rows
      for (let i = 1; i < this.bulkInvitationList.length; i++) {
        this.bulkInvitationList[i].indComponentList = [...firstRow.indComponentList];
        this.bulkInvitationList[i].packCompList = [...firstRow.packCompList];
        this.bulkInvitationList[i].packageId = firstRow.packageId;
      }

    } else {
      // Clear selections for all except the first row
      for (let i = 1; i < this.bulkInvitationList.length; i++) {
        this.bulkInvitationList[i].indComponentList = [];
        this.bulkInvitationList[i].packCompList = [];
        this.bulkInvitationList[i].packageId = 0;
      }
    }
  }



}
export class BulkUploadDoc {
  invitationFlag: boolean;
  fileName: string;
  clientId: number;
  clientName: string;
  siteId: number;
  siteName: string;
  autoAssignFlag: boolean;
  loggedId: number;
  bulkUploadDoc: any;
  uploadStatus: boolean;
  verflag: boolean;
  deptId: number;
  teamId: number;
  isAllowExistInvitation: boolean;
}

export class BulkInvitation {
  //[x: string]: any;
  firstName: string;
  middleName: string;
  lastName: string;
  mobileNumber: string;
  email: string;
  ccMail: string;
  expiryDays: number;
  eConsent: string;
  chargeCode: string;
  applicantId: string;
  package?: string;
  individualComponents?: string;
  remarks: string;
  indComponentList?: any[] = [];
  packCompList?: any[] = [];
  packageId?: number;

  constructor(data: any) {
    this.firstName = data["FIRST NAME"] || "";
    this.middleName = data["MIDDLE NAME"] || "";
    this.lastName = data["LAST NAME"] || "";
    this.mobileNumber = data["MOBILE NUMBER"] || "";
    this.email = data["EMAIL"] || "";
    this.ccMail = data["CC Mail"] || "";
    this.expiryDays = data["EXPIRY DAYS"] || 0;
    this.eConsent = data["E-CONSENT"] || "";
    this.chargeCode = data["CHARGE CODE"] || "";
    this.applicantId = data["APPLICANT ID"] || "";
    this.remarks = data["Remarks"] || "";
    this.packageId = 0;
  }
}

